import { lazy, Suspense } from 'react'
import { Link } from 'react-router'
import { BRAND } from '../constants/brandAssets'

const ThreeCanvas = lazy(() => import('../three/ThreeCanvas').then((m) => ({ default: m.ThreeCanvas })))

function HeroFallback() {
  return (
    <div
      className="relative isolate min-h-[280px] h-[min(44vh,440px)] w-full overflow-hidden rounded-2xl border border-white/[0.08] bg-gradient-to-b from-kavach-surface to-kavach-bg shadow-panel"
      aria-hidden
    >
      <div
        className="absolute inset-0 opacity-[0.35]"
        style={{
          backgroundImage:
            'radial-gradient(ellipse 80% 60% at 50% 20%, rgba(255,140,66,0.22), transparent 55%)',
        }}
      />
      <div className="absolute inset-0 animate-pulse bg-gradient-to-b from-white/[0.04] to-transparent" />
    </div>
  )
}

export function HomePage() {
  return (
    <div className="flex scroll-smooth flex-col gap-8">
      <Suspense fallback={<HeroFallback />}>
        <ThreeCanvas />
      </Suspense>
      <div className="grid gap-4 md:grid-cols-2">
        <div className="flex flex-col gap-4 rounded-2xl border border-white/[0.08] bg-kavach-surface/80 p-6 shadow-panel sm:flex-row sm:items-stretch">
          <img
            src={BRAND.homeSwapCardImage}
            alt=""
            width={88}
            height={88}
            className="h-20 w-20 shrink-0 self-start rounded-xl object-contain ring-1 ring-white/10 sm:h-[5.5rem] sm:w-[5.5rem]"
            decoding="async"
          />
          <div className="flex min-w-0 flex-1 flex-col">
            <div className="flex flex-wrap items-start justify-between gap-3">
              <h2 className="font-display text-xl font-semibold text-white">Trade</h2>
              <div className="flex flex-wrap items-center gap-2">
                <Link
                  to="/swap"
                  className="inline-flex rounded-xl bg-emerald-500/15 px-4 py-2 text-sm font-medium text-emerald-400 ring-1 ring-emerald-500/35 hover:bg-emerald-500/25 md:text-base"
                >
                  Open Swap
                </Link>
                <Link
                  to="/swap/stable"
                  className="inline-flex rounded-xl bg-white/[0.06] px-4 py-2 text-sm font-medium text-slate-300 ring-1 ring-white/[0.1] hover:bg-white/[0.1] md:text-base"
                >
                  Stable
                </Link>
              </div>
            </div>
            <p className="mt-2 text-sm text-slate-400">
              Swap tokens with live quotes, slippage limits, and deadline controls.
            </p>
          </div>
        </div>
        <div className="flex flex-col gap-4 rounded-2xl border border-white/[0.08] bg-kavach-surface/80 p-6 shadow-panel sm:flex-row sm:items-stretch">
          <img
            src={BRAND.homeLiquidityCardImage}
            alt=""
            width={88}
            height={88}
            className="h-20 w-20 shrink-0 self-start rounded-xl object-contain ring-1 ring-white/10 sm:h-[5.5rem] sm:w-[5.5rem]"
            decoding="async"
          />
          <div className="flex min-w-0 flex-1 flex-col">
            <div className="flex flex-wrap items-start justify-between gap-3">
              <h2 className="font-display text-xl font-semibold text-white">Liquidity</h2>
              <Link
                to="/pools"
                className="inline-flex rounded-xl bg-emerald-500/12 px-4 py-2 text-sm font-medium text-emerald-400 ring-1 ring-emerald-500/30 hover:bg-emerald-500/20 md:text-base"
              >
                Pools
              </Link>
            </div>
            <p className="mt-2 text-sm text-slate-400">
              Add CLMM, CPMM, or stable liquidity — dedicated tabs in the nav.
            </p>
            <div className="mt-4 flex flex-wrap gap-2">
              <Link to="/liquidity/v3" className="rounded-lg bg-white/[0.06] px-3 py-1.5 text-sm hover:bg-white/[0.1]">
                CLMM
              </Link>
              <Link to="/liquidity/cpmm" className="rounded-lg bg-white/[0.06] px-3 py-1.5 text-sm hover:bg-white/[0.1]">
                CPMM
              </Link>
              <Link to="/liquidity/stable" className="rounded-lg bg-white/[0.06] px-3 py-1.5 text-sm hover:bg-white/[0.1]">
                Stable
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
